// ═══════════════════════════════════════════════════════════════
//  focusTache.js — « aller à LA tâche » depuis la bannière d'accueil (T16)
//
//  ⚠️ CE FICHIER N'IMPORTE RIEN — testé en `node` pur (focusTache.test.js).
//  Stockage INJECTÉ (sessionStorage côté appelant), même raison que replis.js.
//
//  🔴 POURQUOI « LIRE » ET « EFFACER » SONT DEUX FONCTIONS, et pas un seul
//  `prendreFocus` qui lit puis efface. Sous <StrictMode> (React 18.3), le
//  PREMIER montage d'un composant est rendu deux fois, et le second rendu
//  repart de hooks NEUFS (`renderWithHooks(null, …)` dans react-dom) : un
//  `useRef` posé au premier rendu n'existe plus au second. Une lecture
//  destructive faite au rendu renverrait donc l'id, puis null — le surlignage
//  disparaîtrait en dev, exactement le bug T8-bis. D'où :
//    • lireFocus   au RENDU  — idempotent, deux lectures = même valeur ;
//    • effacerFocus dans un EFFET — les effets rejoués par StrictMode gardent
//      l'état et les refs du composant, effacer deux fois est sans effet.
// ═══════════════════════════════════════════════════════════════

export const CLE_FOCUS = "epj.taches.focus";

// Ne jette jamais. Un id vide ou blanc ne pose rien.
export function poserFocus(storage, id) {
  const v = id != null ? String(id).trim() : "";
  if (!v || !storage) return;
  try {
    storage.setItem(CLE_FOCUS, v);
  } catch {
    /* focus perdu : l'écran s'ouvre simplement sans surlignage */
  }
}

// → id ou null. N'efface rien.
export function lireFocus(storage) {
  try {
    const v = storage ? storage.getItem(CLE_FOCUS) : null;
    return typeof v === "string" && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

// Ne jette jamais. À appeler une fois le focus lu : il ne vaut que pour
// l'ouverture qui suit le clic, pas pour la prochaine visite.
export function effacerFocus(storage) {
  try {
    if (storage) storage.removeItem(CLE_FOCUS);
  } catch {
    /* rien à faire */
  }
}
